import { render, staticRenderFns } from "./documentsAdmin.vue?vue&type=template&id=db1f80e8"
import script from "./documentsAdmin.vue?vue&type=script&lang=js"
export * from "./documentsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports